import { render, staticRenderFns } from "./StudentGraduationProcess.vue?vue&type=template&id=02712762&scoped=true"
import script from "./StudentGraduationProcess.vue?vue&type=script&lang=js"
export * from "./StudentGraduationProcess.vue?vue&type=script&lang=js"
import style0 from "./StudentGraduationProcess.vue?vue&type=style&index=0&id=02712762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02712762",
  null
  
)

export default component.exports